export type IconsId =
  | "x-circle"
  | "settings"
  | "search"
  | "pie-chart"
  | "paperclip"
  | "info"
  | "filter"
  | "eye"
  | "eye-off"
  | "edit-new"
  | "drag-handle"
  | "crosshair"
  | "close"
  | "circle"
  | "chevron"
  | "check-circle"
  | "arrow-up"
  | "arrow-right"
  | "arrow-left"
  | "arrow-down";

export type IconsKey =
  | "XCircle"
  | "Settings"
  | "Search"
  | "PieChart"
  | "Paperclip"
  | "Info"
  | "Filter"
  | "Eye"
  | "EyeOff"
  | "EditNew"
  | "DragHandle"
  | "Crosshair"
  | "Close"
  | "Circle"
  | "Chevron"
  | "CheckCircle"
  | "ArrowUp"
  | "ArrowRight"
  | "ArrowLeft"
  | "ArrowDown";

export enum Icons {
  XCircle = "x-circle",
  Settings = "settings",
  Search = "search",
  PieChart = "pie-chart",
  Paperclip = "paperclip",
  Info = "info",
  Filter = "filter",
  Eye = "eye",
  EyeOff = "eye-off",
  EditNew = "edit-new",
  DragHandle = "drag-handle",
  Crosshair = "crosshair",
  Close = "close",
  Circle = "circle",
  Chevron = "chevron",
  CheckCircle = "check-circle",
  ArrowUp = "arrow-up",
  ArrowRight = "arrow-right",
  ArrowLeft = "arrow-left",
  ArrowDown = "arrow-down",
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.XCircle]: "61697",
  [Icons.Settings]: "61698",
  [Icons.Search]: "61699",
  [Icons.PieChart]: "61700",
  [Icons.Paperclip]: "61701",
  [Icons.Info]: "61702",
  [Icons.Filter]: "61703",
  [Icons.Eye]: "61704",
  [Icons.EyeOff]: "61705",
  [Icons.EditNew]: "61706",
  [Icons.DragHandle]: "61707",
  [Icons.Crosshair]: "61708",
  [Icons.Close]: "61709",
  [Icons.Circle]: "61710",
  [Icons.Chevron]: "61711",
  [Icons.CheckCircle]: "61712",
  [Icons.ArrowUp]: "61713",
  [Icons.ArrowRight]: "61714",
  [Icons.ArrowLeft]: "61715",
  [Icons.ArrowDown]: "61716",
};
